export const BG_PRIMARY = '#FFF';
export const BG_SECONDARY = 'rgba(28,117,188,1)';
export const BG_ALTERNATIVE = 'rgba(40,54,141,1)';

export const TEXT_PRIMARY = BG_ALTERNATIVE;
export const TEXT_SECONDARY = '#FFF';
export const TEXT_PRIMARY_LIGHT = '#FFF';

export const BTN_NAVIGATION_COLOR = BG_ALTERNATIVE;

// Opacity layer for left content (Desktop view)
export const BG_SECONDARY_TRANSPARENT = '';
